__turbopack_context__.v({
  "className": "saudiriyyal_a5613aa-module__VSECaa__className",
});
